// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2m_Qf{position:absolute;top:0;width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;color:#fff}.m7vFD,.-b9js{margin-bottom:1.5rem}._3U8xy{display:-ms-flexbox;display:flex}@media(max-width:1023px){._3U8xy{display:none}}._3U8xy>*{margin-right:1.5rem}._3U8xy>:last-child{margin-right:0}", ""]);
// Exports
exports.locals = {
	"root": "_2m_Qf",
	"description": "m7vFD",
	"title": "-b9js",
	"buttonGroup": "_3U8xy"
};
module.exports = exports;
